(function($, undefined) {

	/**
	 * @author Radek Šerý
	 *
	 * Lazyload obrázků po AJAXovém překreslení části stránky.
	 */
	$.nette.ext('lazyload', {
		init: function() {
			var snippetsExt = this.ext('snippets', true);
			var ext = this;

			// Obecný lazyload
			ext.instances.push(new LazyLoad(
				$.extend({}, ext.settings, {
					elements_selector: '.js-lazy:not(.js-lazy--manual)',
					thresholds: ext.thresholds,
				})
			));

		},
		success: function () {
			this.update();
		}
	}, {
		instances: [],
		thresholds: '300px 150px',
		settings: {
			class_loaded: 'js-lazy--loaded',
			class_loading: 'js-lazy--loading',
			class_error: 'js-lazy--error',
			callback_loaded: function(el) {
				$(el).parent('picture').addClass('js-lazy-picture--loaded');
			}
		},
		update: function () {
			this.instances.forEach(function(instance, index) {
				instance.update();
			})
		}
	});

})(jQuery);
